var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-container',{attrs:{"title":"Error","description":"","icon":"mdi-error"}},[_vm._v(" Errore generico ")])
}
var staticRenderFns = []

export { render, staticRenderFns }